import React, { memo, useEffect, useState } from "react";
import {
  Button,
  OverlayTrigger,
  Tooltip
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./index.css";

const DEFAULT_ZINDEX = 1000;
const SCALE_HOVER = 1;
const SCALE_NORMAL = 0.65;

const Point = ({ color, edit, index, onClick, supportPoint }) => {
  const { t } = useTranslation();

  const [pointHover, setPointHover] = useState(false);
  const [popupShow, setPopupShow] = useState(false);

  const [scale, setScale] = useState(SCALE_NORMAL);
  const [zIndex, setZIndex] = useState(DEFAULT_ZINDEX);

  const [indexSelected, setIndexSelected] = useState(index);

  useEffect(() => {
    if (edit === -1) {
      setScale(pointHover || popupShow ? SCALE_HOVER : SCALE_NORMAL);
      setZIndex(Math.round(scale * DEFAULT_ZINDEX) - (popupShow ? 20 : 0) + (pointHover ? DEFAULT_ZINDEX : 0));
    }
  }, [pointHover, popupShow, scale]); /* eslint-disable-line */

  useEffect(() => {
    if (edit !== index) {
      setPopupShow(false);
      setPointHover(false);
      setScale(SCALE_NORMAL);
      setZIndex(Math.round(SCALE_NORMAL * DEFAULT_ZINDEX));
    }
    else {
      setPopupShow(true);
      setPointHover(true);
      setScale(SCALE_HOVER);
      setZIndex(Math.round(SCALE_HOVER * DEFAULT_ZINDEX) - 20 + DEFAULT_ZINDEX);
    }
  }, [edit]); /* eslint-disable-line */

  useEffect(() => {
    setIndexSelected(index);
  }, [index]);

  const popup = (
    <div
      id={`point-marker-popup-${index}`}
      className="marker-point-popup"
      onClick={e => e.stopPropagation()}
    >
      <h3 className="mepoint-title">{t(`Title.SupportPoint.${supportPoint.type}`)}:</h3>
      <div className="mepoint-content">
        <ul>
          <li>
            <div>{t("Title.Name")}:</div>
            <div>{supportPoint.name}</div>
          </li>
          <li>
            <div>{t("Title.Range")}:</div>
            <div>{supportPoint.range}</div>
          </li>
          <li>
            <div>{t("Title.Actions")}:</div>
            <div>
              <div>
                <OverlayTrigger overlay={<Tooltip>{edit !== index ? t("Button.Edit") : t("Button.Cancel")}</Tooltip>}>
                  <Button
                    className="mepoint-content-button"
                    variant="dark"
                    type="button"
                    onClick={() => {
                      onClick(2, index);
                      setIndexSelected(index);
                    }}
                  >
                    {
                      edit !== index ? <i className="fas fa-edit" /> : <i className="fas fa-times" />
                    }
                  </Button>
                </OverlayTrigger>
              </div>
              <div>
                <OverlayTrigger overlay={<Tooltip>{t("Button.Remove")}</Tooltip>}>
                  <Button
                    className="mepoint-content-button"
                    variant="dark"
                    type="button"
                    onClick={() => edit === index ? onClick(3, index) : false}
                    disabled={edit === index ? false : true}
                  >
                    <i className="fas fa-trash-alt" />
                  </Button>
                </OverlayTrigger>
              </div>
            </div>
          </li>
          <li>
            <div></div>
            <div>
              <div>
                <OverlayTrigger overlay={<Tooltip>{t("Button.Save")}</Tooltip>}>
                  <Button
                    className="mepoint-content-button"
                    variant="dark"
                    type="button"
                    onClick={() => edit === index ? onClick(4, index, indexSelected) : false}
                    disabled={edit === index ? false : true}
                  >
                    <i className="fas fa-check" />
                  </Button>
                </OverlayTrigger>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );

  return (
    <div
      className="marker-point-all"
      onClick={e => {
        if (edit === -1) {
          setPopupShow(!popupShow);
          onClick(popupShow ? 0 : 1);
        }
      }}
      onMouseEnter={e => setPointHover(true)}
      onMouseLeave={e => setPointHover(false)}
      style={{
        background: `${color}`,
        transform: `translateX(-50%) translateY(-50%) scale(${scale} , ${scale})`,
        MozTransform: `translateX(-50%) translateY(-50%) scale(${scale} , ${scale})`,
        WebkitTransform: `translateX(-50%) translateY(-50%) scale(${scale} , ${scale})`,
        zIndex: zIndex
      }}
    >
      <div className="marker-point">
        <div
          className="icon"
          style={{
            color: `${color}`
          }}
        >{(index + 1)}</div>
        {popupShow && popup}
      </div>
    </div>
  );
};

export default memo(Point);
